module.exports = "img/selected.f0a69a0.png";